import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import EmptyView from '../EmptyView';

enum ErrorTypes {
  LoadError = 1,
  CodeError = 2,
  NoError = 0,
}

export default function <T>(Comp: React.ComponentType<T>) {
  const WrapperClass = class extends React.PureComponent<T> {
    // eslint-disable-next-line react/sort-comp
    state = {
      errorType: ErrorTypes.NoError,
    };

    static getDerivedStateFromError(error: Error) {
      switch (error.name) {
        case 'ChunkLoadError':
          return {
            errorType: ErrorTypes.LoadError,
          };
        default:
          return {
            errorType: ErrorTypes.CodeError,
          };
      }
    }

    componentDidCatch(error: Error) {
      if (this.state.errorType !== ErrorTypes.LoadError) {
        window.Sentry && Sentry.captureException(error);
        if (
          process.env.NODE_ENV === 'development' ||
          process.env.APP_ENV !== 'prod'
        ) {
          console.log(error, error.name, error.message, error.stack);
        }
      }
    }

    render() {
      if (this.state.errorType === ErrorTypes.NoError) {
        return <Comp {...this.props} />;
      }

      let errorMessage = '';

      switch (this.state.errorType) {
        case 1:
          errorMessage = '哎呀，页面加载失败了';
          break;
        default:
          errorMessage = '哎呀，页面竟然崩溃了';
      }

      return (
        <EmptyView
          text={
            <div
              onClick={() => {
                // TODO: 不要页面刷新
                window.location.reload();
              }}
            >
              {errorMessage}，请点击重试
            </div>
          }
        />
      );
    }
  };

  hoistNonReactStatics(WrapperClass, Comp);

  return WrapperClass;
}
